import { Component, OnInit, Input } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { CommonFunctionsService } from '../common-functions.service';
import { ModalController } from '@ionic/angular';
import { General_Config } from '../General_Config';

@Component({
  selector: 'app-availcoupon',
  templateUrl: './availcoupon.page.html',
  styleUrls: ['./availcoupon.page.scss'],
})
export class AvailcouponPage implements OnInit {
  isLoading: boolean = true;
  data: any = { avail: [], unavail: [] };
  @Input() shop: string;
  @Input() total: number;
  constructor(public modalController: ModalController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ngOnInit() {
    let location = JSON.parse(window.localStorage.getItem(General_Config.session_key + 'location'));
    this.restApi.get('get_avail_coupons/' + location.code + '/' + this.shop + '/' + this.total).subscribe({
      next: (data: any) => {
        this.isLoading = false;
        if (data['code'] == 200) {
          this.data = data['data'];
        } else {
          this.commonFunctions.presentAlertConfirm('Information', data['message']);
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.commonFunctions.presentAlertConfirm('Information', error);
      }
    });
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  selectCoupon(item) {
    this.modalController.dismiss({
      'success': true,
      'coupon': item
    });
  }
}
